export const  reducerUpdateObject= (oldObject, updatedProperties)=>{
    // return {
    //   ...oldObject,
    //   ...updatedProperties,
    // };
    return Object.assign({}, oldObject, updatedProperties);
  };